"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMeshSelector = useMeshSelector;
const styled_components_1 = require("styled-components");
function useMeshSelector(maybeSelector) {
  const theme = (0, styled_components_1.useTheme)();
  // Some Mesh functions (like pickColor) may return strings like "transparent"
  if (typeof maybeSelector === "string") {
    return maybeSelector;
  }
  // This trick is used in a few places inside mesh, to trick a selector into
  // thinking it's receiving props. I have yet to find a selector that needs
  // more than just the theme
  return maybeSelector({
    theme
  });
}